import React, { forwardRef } from 'react';
import { Typography } from '@mui/material';
import { readAppLanguage } from '../../i18n';
import SingleLineText from './SingleLineText';

// Preserve Korean sizing; longer international headings and explanations can wrap.
export default forwardRef(function InternationalText({ sx, minFontSize, ...props }, ref) {
    if (readAppLanguage() === 'ko') return <SingleLineText {...props} sx={sx} minFontSize={minFontSize} ref={ref} />;
    return <Typography {...props} ref={ref} sx={[...(Array.isArray(sx) ? sx : [sx]),
        { minWidth: 0, maxWidth: '100%', whiteSpace: 'normal', overflowWrap: 'anywhere' }]} />;
});
